import { render, staticRenderFns } from "./CallsTable.vue?vue&type=template&id=5363fd1f&"
import script from "./CallsTable.vue?vue&type=script&lang=ts&"
export * from "./CallsTable.vue?vue&type=script&lang=ts&"
import style0 from "./CallsTable.vue?vue&type=style&index=0&id=5363fd1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports